//import {forEach} from "lodash";

import {Query} from "@/Helpers/propertiesQueryBuilder";

export class Bounds {

    ne_lat = null;
    ne_lng = null;
    sw_lat = null;
    sw_lng = null;

    toString() {
      return Object.keys(this.getPayload()).map(key => key + '=' + this.getPayload()[key]).join('&');
    }
    fromString(value) {
      let params = new URLSearchParams(value);
      if(params.get('ne_lat')) { this.ne_lat = params.get('ne_lat') }
      if(params.get('ne_lng')) { this.ne_lng = params.get('ne_lng') }
      if(params.get('sw_lat')) { this.sw_lat = params.get('sw_lat') }
      if(params.get('sw_lng')) { this.sw_lng = params.get('sw_lng') }
    }

    clone() {
      const query = new Query();
      query.fromString(this.toString());
      return query;
    }
}
